const TermsConditions = () => {
	return (
		<section className="py-24 bg-white text-gray-800">
			<div className="max-w-screen-xl mx-auto px-4">
				<div className="mx-auto max-w-4xl">
					{/* Title and Date */}
					<div className="mb-12 text-center">
						<h2 className="mb-3 text-3xl font-semibold md:text-4xl">
							T&amp;C SYARAT PENGGUNAAN JASA INDOEROPA.com
						</h2>

						<p className="text-lg font-semibold text-primary">
							Bayar = Setuju dengan T&amp;C
						</p>

						<p className="subtext mt-2 text-gray-600">
							Last updated 01.01.2026
						</p>
					</div>

					{/* Indonesian Version */}
					<div className="mb-14">
						<h3 className="mb-6 text-2xl font-semibold text-gray-800">
							Syarat &amp; Ketentuan
						</h3>

						<div className="space-y-10 leading-relaxed">
							<div className="space-y-10 rounded-2xl border border-gray-200 bg-gray-50 p-6 shadow-sm">
								<ol className="list-decimal space-y-6 pl-5 subtext">
									<li>
										Barang yang dikirimkan ke kami
										sepenuhnya adalah milik pemilik barang
										(pemesan/pengirim).{" "}
										<strong>
											Kami hanya bertindak sebagai pembawa
											barang
										</strong>{" "}
										dari lokasi asal ke tujuan yang telah
										disepakati.
									</li>

									<li>
										<p>
											Pemilik barang bertanggung jawab
											penuh atas isi paket yang
											dikirimkan.
										</p>

										<ul className="mt-3 list-disc space-y-2 pl-6">
											<li>
												Jika terjadi masalah hukum atau
												penyitaan oleh pihak berwenang
												(Bea Cukai, Kepolisian, atau
												otoritas lain), maka seluruh
												tanggung jawab biaya &amp;
												barang ada pada pemilik barang.
											</li>
											<li>
												Kami{" "}
												<strong>
													tidak bertanggung jawab atas
													biaya materil bea masuk,
													pajak, atau denda
												</strong>{" "}
												yang dikenakan terhadap barang.
											</li>
										</ul>
									</li>

									<li>
										<p>
											Barang harus dikirimkan ke gudang
											kami sesuai jadwal yang telah
											ditentukan.
											<strong>
												Tidak ada refund
											</strong>{" "}
											dalam bentuk apapun untuk
											keterlambatan.
										</p>

										<ul className="mt-3 list-disc space-y-2 pl-6">
											<li>
												Jika{" "}
												<strong>
													barang datang terlambat ke
													gudang kami, kami tidak
													bertanggung jawab
												</strong>{" "}
												atas keterlambatan pengiriman
												dalam bentuk apapun.
											</li>
											<li>
												Jika barang tiba setelah H-2
												pukul 17.00 sebelum jadwal
												pengiriman,{" "}
												<strong>
													kami berhak menolak
													pengiriman tanpa refund
												</strong>
												.
											</li>
										</ul>
									</li>

									<li>
										<p>
											Barang yang dikirimkan kepada kami
											wajib dikonfirmasi melalui WhatsApp
											sebelum pengiriman dilakukan.
										</p>

										<ul className="mt-3 list-disc space-y-2 pl-6">
											<li>
												Barang yang tidak dikonfirmasi
												tidak akan kami proses.
											</li>
											<li>
												Kami hanya bertanggung jawab
												untuk membawa barang yang telah
												dikonfirmasi oleh pemiliknya.
											</li>
										</ul>
									</li>

									<li>
										<p>
											Barang akan dibongkar dan dipacking
											ulang untuk memastikan keamanan
											selama perjalanan.
										</p>

										<ul className="mt-3 list-disc space-y-2 pl-6">
											<li>
												Jika ditemukan barang yang
												melanggar aturan penerbangan
												atau hukum setempat, barang akan
												dikeluarkan tanpa pemberitahuan
												dan tidak ada refund.
											</li>
										</ul>
									</li>
								</ol>

								<div className="mt-8 rounded-xl border border-red-200 bg-red-50 p-4">
									<h4 className="mb-2 font-semibold text-red-800">
										List barang larangan
									</h4>
									<p className="text-sm text-red-800 subtext">
										Segala jenis tumbuhan &amp; bibit
										tanaman, obat-obatan tidak tersegel,
										daging mentah, biji-bijian, narkoba,
										vitamin tidak bermerk, onderdil
										terlarang, dan bahan mudah meledak.
									</p>
								</div>

								<div>
									<h4 className="mb-4 text-xl font-semibold">
										Risiko &amp; Tanggung Jawab Pemilik
										Barang
									</h4>

									<ol className="list-decimal space-y-6 pl-5 subtext">
										<li>
											<p>
												Segala risiko terkait dengan
												barang sepenuhnya menjadi
												tanggung jawab pemilik barang,
												bukan pihak jasa pengiriman
												kami.
											</p>

											<ul className="mt-3 list-disc space-y-2 pl-6">
												<li>
													Jika barang hilang, rusak,
													atau terlambat oleh pihak
													kurir lokal, maka kami hanya
													akan membantu membuat
													laporan.
												</li>
												<li>
													Jika barang tertahan oleh
													Bea Cukai dan pemilik barang
													tidak melakukan pembayaran
													dalam 3x24 jam, maka barang
													sepenuhnya milik kami dan
													kami tidak bertanggung jawab
													atas kompensasi dalam bentuk
													apa pun.
												</li>
											</ul>
										</li>

										<li>
											<p>
												Kami tidak bertanggung jawab
												atas keterlambatan pengiriman
												barang yang disebabkan oleh:
											</p>

											<ul className="mt-3 list-disc space-y-2 pl-6">
												<li>
													Keterlambatan pemilik barang
													atau kurir lokal dalam
													mengirimkan barang ke gudang
													kami.
												</li>
												<li>
													Masalah transportasi atau
													penundaan penerbangan.
												</li>
												<li>
													Proses pemeriksaan di Bea
													Cukai.
												</li>
												<li>
													Force majeure, termasuk
													bencana alam, kebijakan
													negara, atau hal lain di
													luar kendali kami.
												</li>
											</ul>
										</li>
									</ol>
								</div>

								<div>
									<h4 className="mb-4 text-xl font-semibold">
										Kebijakan Refund &amp; Keterlambatan
									</h4>

									<ol className="list-decimal space-y-6 pl-5 subtext">
										<li>
											<p>
												Tidak ada refund dalam kondisi
												berikut:
											</p>

											<ul className="mt-3 list-disc space-y-2 pl-6">
												<li>
													Jika barang datang terlambat
													ke gudang kami H-2 pukul
													17.00, maka keterlambatan
													pengiriman ke tujuan
													sepenuhnya menjadi tanggung
													jawab pemesan.
												</li>
												<li>
													Jika barang tersita oleh
													pihak Bea Cukai.
												</li>
												<li>
													Jika berat atau jumlah
													barang kurang dari jumlah
													total pesanan.
												</li>
											</ul>
										</li>

										<li>
											<p>
												Kami bertanggung jawab penuh
												atas kondisi barang selama
												proses pengiriman dari Jerman ke
												Indonesia atau sebaliknya.
											</p>

											<ul className="mt-3 list-disc space-y-2 pl-6">
												<li>
													Jika terjadi kerusakan
													mayor, yaitu barang tidak
													berfungsi total selama
													perjalanan Jerman -
													Indonesia atau Indonesia -
													Jerman, kami akan
													bertanggung jawab penuh
													sesuai ketentuan yang telah
													disepakati.
												</li>
												<li>
													Jika terjadi kelalaian dari
													pihak kami, seperti
													kehilangan atau kesalahan
													lainnya, kami akan
													memberikan ganti rugi sesuai
													ketentuan yang telah
													disepakati bersama.
												</li>
											</ul>
										</li>
									</ol>
								</div>
							</div>

							<div className="rounded-2xl border border-primary-100 bg-primary-50 p-6">
								<p className="font-medium text-gray-900">
									Segala bentuk tindakan yang tidak menyetujui
									T&amp;C akan kami proses dengan hukum
									Indonesia di bawah badan usaha CV.
									Indoeropa.
								</p>
							</div>

							<div>
								<p>Best regards,</p>
								<p className="mt-4 font-semibold">
									Indoeropa.com
								</p>
								<p className="font-semibold">INDOEROPA.com</p>
							</div>
						</div>
					</div>

					<div className="my-14 border-t border-gray-300"></div>

					{/* English Version */}
					<div>
						<h3 className="mb-6 text-2xl font-semibold text-gray-800">
							Terms &amp; Conditions
						</h3>

						<div className="space-y-10 leading-relaxed">
							<div className="space-y-10 rounded-2xl border border-gray-200 bg-gray-50 p-6 shadow-sm">
								<ol className="list-decimal space-y-6 pl-5 subtext">
									<li>
										The goods sent to us remain fully owned
										by the owner of the goods
										(customer/sender).{" "}
										<strong>
											We only act as the carrier of the
											goods
										</strong>{" "}
										from the origin to the agreed
										destination.
									</li>

									<li>
										<p>
											The owner of the goods is fully
											responsible for the contents of the
											package being sent.
										</p>

										<ul className="mt-3 list-disc space-y-2 pl-6">
											<li>
												If legal issues or seizure by
												authorities occur, including
												Customs, Police, or other
												authorities, all responsibility
												for costs and goods lies with
												the owner of the goods.
											</li>
											<li>
												We are{" "}
												<strong>
													not responsible for customs
													duties, taxes, fines, or
													other material costs
												</strong>{" "}
												imposed on the goods.
											</li>
										</ul>
									</li>

									<li>
										<p>
											Goods must be delivered to our
											warehouse according to the
											determined schedule.{" "}
											<strong>There is no refund</strong>{" "}
											in any form for delays.
										</p>

										<ul className="mt-3 list-disc space-y-2 pl-6">
											<li>
												If{" "}
												<strong>
													the goods arrive late at our
													warehouse, we are not
													responsible
												</strong>{" "}
												for any shipment delay in any
												form.
											</li>
											<li>
												If the goods arrive after H-2 at
												17:00 before the shipment
												schedule,{" "}
												<strong>
													we have the right to refuse
													the shipment without refund
												</strong>
												.
											</li>
										</ul>
									</li>

									<li>
										<p>
											Goods sent to us must be confirmed
											via WhatsApp before shipment is
											made.
										</p>

										<ul className="mt-3 list-disc space-y-2 pl-6">
											<li>
												Unconfirmed goods will not be
												processed.
											</li>
											<li>
												We are only responsible for
												carrying goods that have been
												confirmed by their owner.
											</li>
										</ul>
									</li>

									<li>
										<p>
											Goods will be unpacked and repacked
											to ensure safety during transit.
										</p>

										<ul className="mt-3 list-disc space-y-2 pl-6">
											<li>
												If goods are found to violate
												flight regulations or local
												laws, they will be removed
												without prior notice and no
												refund will be provided.
											</li>
										</ul>
									</li>
								</ol>

								<div className="mt-8 rounded-xl border border-red-200 bg-red-50 p-4">
									<h4 className="mb-2 font-semibold text-red-800">
										Prohibited items
									</h4>
									<p className="text-sm text-red-800 subtext">
										All types of plants and plant seeds,
										unsealed medicine, raw meat, seeds,
										narcotics, unbranded vitamins,
										prohibited spare parts, and explosive
										materials.
									</p>
								</div>

								<div>
									<h4 className="mb-4 text-xl font-semibold">
										Risks &amp; Responsibilities of the
										Goods Owner
									</h4>

									<ol className="list-decimal space-y-6 pl-5 subtext">
										<li>
											<p>
												All risks related to the goods
												are fully the responsibility of
												the owner of the goods, not the
												shipping service provider.
											</p>

											<ul className="mt-3 list-disc space-y-2 pl-6">
												<li>
													If the goods are lost,
													damaged, or delayed by the
													local courier, we will only
													assist in creating a report.
												</li>
												<li>
													If the goods are held by
													Customs and the owner does
													not make payment within 3x24
													hours, the goods will fully
													belong to us and we are not
													responsible for any
													compensation in any form.
												</li>
											</ul>
										</li>

										<li>
											<p>
												We are not responsible for
												shipment delays caused by:
											</p>

											<ul className="mt-3 list-disc space-y-2 pl-6">
												<li>
													Delays by the owner of the
													goods or local courier in
													sending the goods to our
													warehouse.
												</li>
												<li>
													Transportation issues or
													flight delays.
												</li>
												<li>
													Customs inspection
													processes.
												</li>
												<li>
													Force majeure, including
													natural disasters,
													government policies, or
													other matters outside our
													control.
												</li>
											</ul>
										</li>
									</ol>
								</div>

								<div>
									<h4 className="mb-4 text-xl font-semibold">
										Refund Policy &amp; Delays
									</h4>

									<ol className="list-decimal space-y-6 pl-5 subtext">
										<li>
											<p>
												No refund will be provided under
												the following conditions:
											</p>

											<ul className="mt-3 list-disc space-y-2 pl-6">
												<li>
													If the goods arrive late at
													our warehouse after H-2 at
													17:00, the delay in delivery
													to the destination is fully
													the responsibility of the
													customer.
												</li>
												<li>
													If the goods are seized by
													Customs.
												</li>
												<li>
													If the weight or quantity of
													the goods is less than the
													total order amount.
												</li>
											</ul>
										</li>

										<li>
											<p>
												We are fully responsible for the
												condition of the goods during
												the shipment process from
												Germany to Indonesia or vice
												versa.
											</p>

											<ul className="mt-3 list-disc space-y-2 pl-6">
												<li>
													If major damage occurs,
													meaning the item becomes
													completely non-functional
													during the Germany -
													Indonesia or Indonesia -
													Germany journey, we will
													take full responsibility
													according to the agreed
													terms.
												</li>
												<li>
													If negligence occurs on our
													part, such as loss or other
													mistakes, we will provide
													compensation according to
													the terms agreed together.
												</li>
											</ul>
										</li>
									</ol>
								</div>
							</div>

							<div className="rounded-2xl border border-primary-100 bg-primary-50 p-6">
								<p className="font-medium text-gray-900">
									Any action that does not agree with these
									T&amp;C will be processed under Indonesian
									law under the business entity CV. Indoeropa.
								</p>
							</div>

							<div>
								<p>Best regards,</p>
								<p className="mt-4 font-semibold">
									Indoeropa.com
								</p>
								<p className="font-semibold">INDOEROPA.com</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default TermsConditions;
